(function() {
  function qs(root, selector) {
    return (root || document).querySelector(selector);
  }

  function qsa(root, selector) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function moneyHtmlToText(value) {
    var text = String(value || '')
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'");
    return text.replace(/<[^>]*>/g, '').trim();
  }

  function formatMoney(cents, moneyFormat) {
    var amount = Number(cents || 0) / 100;
    var fixed = amount.toFixed(2);
    var parts = fixed.split('.');
    var dollars = parts[0];
    var centsPart = parts[1] || '00';
    var withThousands = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimals = Math.round(amount).toString();
    var noDecimalsWithThousands = noDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withCommaSeparator = withThousands.replace(/,/g, '.') + ',' + centsPart;
    var noDecimalsWithCommaSeparator = noDecimalsWithThousands.replace(/,/g, '.');
    var format = moneyFormat || '${{amount}}';
    var fallback = format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimalsWithCommaSeparator)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommaSeparator)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimalsWithThousands)
      .replace(/\{\{\s*amount\s*\}\}/g, withThousands + '.' + centsPart);

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        var formatted = window.Shopify.formatMoney(cents, format);
        if (formatted && formatted.indexOf('{{') === -1 && formatted.indexOf('}}') === -1) {
          return moneyHtmlToText(formatted);
        }
      } catch (error) {}
    }

    return moneyHtmlToText(fallback);
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function(response) {
      if (!response.ok) {
        return response.json().then(function(data) {
          throw new Error(data.description || 'Unable to add item.');
        });
      }
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('mid-year:cart-refresh'));
      return response.json();
    });
  }

  function processingSpinnerHtml(color) {
    var id = 'mys-loading-' + Math.random().toString(36).slice(2);
    var isBlue = color === '#0062C4' || color === '#0062c4';
    var solid = isBlue ? 'rgba(0,98,196,1)' : 'rgba(255,255,255,1)';
    var transparent = isBlue ? 'rgba(0,98,196,0)' : 'rgba(255,255,255,0)';
    var path = 'M15.4952 5.25C15.2881 4.89128 14.8294 4.76837 14.4707 4.97548C14.112 5.18259 13.989 5.64128 14.1962 6L14.8457 5.625L15.4952 5.25ZM15.6801 9.96857L16.4224 10.0762L15.6801 9.96857ZM13.6464 13.8963L13.1301 13.3522L13.6464 13.8963ZM9.61764 15.7217L9.54901 14.9748V14.9748L9.61764 15.7217ZM5.32369 14.661L4.91521 15.29L5.32369 14.661ZM5.3981 3.29134L5.79831 3.92564L5.3981 3.29134ZM9.62717 3.03287C10.0391 3.07616 10.4082 2.77732 10.4515 2.36537C10.4947 1.95343 10.1959 1.58438 9.78396 1.54109L9.70556 2.28698L9.62717 3.03287ZM14.8457 5.625L14.1962 6C14.87 7.16715 15.1313 8.52719 14.9379 9.86095L15.6801 9.96857L16.4224 10.0762C16.6641 8.40898 16.3375 6.70894 15.4952 5.25L14.8457 5.625ZM15.6801 9.96857L14.9379 9.86095C14.7445 11.1947 14.1077 12.4245 13.1301 13.3522L13.6464 13.8963L14.1627 14.4403C15.3847 13.2807 16.1807 11.7434 16.4224 10.0762L15.6801 9.96857ZM13.6464 13.8963L13.1301 13.3522C12.1525 14.28 10.8911 14.8515 9.54901 14.9748L9.61764 15.7217L9.68627 16.4685C11.3638 16.3144 12.9407 15.5999 14.1627 14.4403L13.6464 13.8963ZM9.61764 15.7217L9.54901 14.9748C8.20695 15.0981 6.86246 14.766 5.73217 14.032L5.32369 14.661L4.91521 15.29C6.32807 16.2076 8.00869 16.6227 9.68627 16.4685L9.61764 15.7217ZM5.32369 14.661L5.73217 14.032C4.60188 13.298 3.75163 12.2048 3.31842 10.9286L2.60822 11.1697L1.89803 11.4108C2.43954 13.006 3.50235 14.3725 4.91521 15.29L5.32369 14.661ZM2.60822 11.1697L3.31842 10.9286C2.88521 9.65245 2.89427 8.26757 3.34415 6.99716L2.63717 6.74681L1.93019 6.49645C1.36784 8.08447 1.35651 9.81556 1.89803 11.4108L2.60822 11.1697ZM2.63717 6.74681L3.34415 6.99716C3.79402 5.72675 4.65851 4.6448 5.79831 3.92564L5.3981 3.29134L4.99789 2.65704C3.57314 3.55599 2.49253 4.90844 1.93019 6.49645L2.63717 6.74681ZM5.3981 3.29134L5.79831 3.92564C6.93811 3.20648 8.28683 2.89199 9.62717 3.03287L9.70556 2.28698L9.78396 1.54109C8.10854 1.36499 6.42263 1.75809 4.99789 2.65704L5.3981 3.29134Z';
    return '<svg class="mys-btn__spinner" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true" focusable="false">' +
      '<g clip-path="url(#' + id + '-clip)"><g transform="matrix(0 0.0075 -0.0075 0 9 9)"><foreignObject x="-1200" y="-1200" width="2400" height="2400"><div xmlns="http://www.w3.org/1999/xhtml" style="background:conic-gradient(from 90deg,' + solid + ' 0deg,' + solid + ' 39.6588deg,' + transparent + ' 191.459deg,' + solid + ' 234deg,' + solid + ' 360deg);height:100%;width:100%;opacity:1"></div></foreignObject></g></g>' +
      '<defs><clipPath id="' + id + '-clip"><path d="' + path + '"/></clipPath></defs>' +
      '</svg>';
  }

  window.MidYearSaleUtils = {
    qs: qs,
    qsa: qsa,
    formatMoney: formatMoney,
    addItems: addItems,
    processingSpinnerHtml: processingSpinnerHtml
  };
})();
